export function formatMetricNumber(value, locale) {
  return new Intl.NumberFormat(locale).format(value ?? 0);
}

export function resolveMetricLocale(language) {
  if (language?.startsWith('en')) return 'en-US';
  if (language?.startsWith('es')) return 'es-ES';
  return 'pt-BR';
}
